import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ModalContainer,
  Header,
} from '@core/dashboard/components/PopoverModal';
import Tools from './Tools';
import Settings from './Settings';
import Collection from './Collection';
import TrainerToolsHeader from './Header';

import { Screens } from '../../interfaces';
import { useTrainerToolsContent as useTrainerTools } from '@features/TrainerTools/provider';

import { useStyles } from './styles';

const Content = ({ onClose }: any) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const { activeScreen, setActiveScreen, activeObject } = useTrainerTools();

  const getHeader = () => {
    switch (activeScreen) {
      case Screens.INIT: {
        return (
          <Header
            text={translate('trainerToolModal.title')}
            onClose={onClose}
          />
        );
      }
      case Screens.COLLECTION: {
        return (
          <TrainerToolsHeader
            onClose={onClose}
            onBack={() => setActiveScreen(Screens.INIT)}
          />
        );
      }
      case Screens.SETTINGS: {
        return (
          <TrainerToolsHeader
            text={activeObject?.name || ''}
            onClose={onClose}
            onBack={() => setActiveScreen(Screens.COLLECTION)}
          />
        );
      }
    }
  };

  const getContent = () => {
    switch (activeScreen) {
      case Screens.INIT: {
        return <Tools onClose={onClose} />;
      }
      case Screens.COLLECTION: {
        return <Collection />;
      }
      case Screens.SETTINGS: {
        return <Settings />;
      }
    }
  };

  return (
    <ModalContainer
      header={getHeader()}
      isScrollable={false}
      sx={
        activeScreen === Screens.COLLECTION
          ? classes.rootCollection
          : classes.root
      }
    >
      {getContent()}
    </ModalContainer>
  );
};

export default Content;
